import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { EaSize } from '../pr-display';

@Component({
    selector: 'pr-risk-level-ladder',
    templateUrl: './pr-risk-level-ladder.component.html',
    styleUrls: ['./pr-risk-level-ladder.component.scss'],
    standalone: false
})
export class PrRiskLevelLadderComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Input() range: [number, number] | number = 1;
  @Input() size: EaSize = EaSize.md;
  @Input() clazz: string;
  _ = _;
  Array = Array;

  constructor() {}

  ngOnInit(): void {
    if (!this.range) this.range = 0;
  }
}
